import { render, staticRenderFns } from "./organizationDialog.vue?vue&type=template&id=4bd94146&scoped=true&"
import script from "./organizationDialog.vue?vue&type=script&lang=js&"
export * from "./organizationDialog.vue?vue&type=script&lang=js&"
import style0 from "./organizationDialog.vue?vue&type=style&index=0&id=4bd94146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd94146",
  null
  
)

export default component.exports